import { useState } from "react";
import { Link } from "react-router-dom";
import { adminRequest } from "lib/adminSiteApi";
import { ActionForm, Fields, Loading, useRemote } from "../workspace/Controls";
import Upload from "../workspace/Upload";
export default function CourseDelivery({ id }) {
  const [tick, setTick] = useState(0),
    [fileId, setFileId] = useState("");
  const state = useRemote("/admin/course-delivery/" + id, tick);
  return (
    <>
      <Link to={"/admin/course-library/" + id}>← Course content</Link>
      <Loading state={state}>
        {state.data && (
          <ActionForm
            key={state.data.record.revision}
            title="Course delivery & enrollment"
            schema={state.data.schema}
            initial={state.data.record}
            description="Keep enrollment closed until the offer, access duration, terms and delivery are approved. Only an owner can open enrollment. Demos cannot open. Changing offer or schedule requires approval again. Files here are private."
            renderFields={(value, setValue) => (
              <Fields
                schema={state.data.schema}
                value={value}
                onChange={setValue}
                reorder
              />
            )}
            submit={(body, key) =>
              adminRequest("/admin/course-delivery/" + id, {
                method: "PUT",
                key,
                body: { ...body, revision: state.data.record.revision },
              })
            }
            onDone={() => setTick((t) => t + 1)}
          />
        )}
      </Loading>
      <Upload courseId={id} onDone={setFileId} />
      {fileId && (
        <p className="aw-notice">
          Private file version: {fileId}.{" "}
          <Link to={"/admin/versions/" + fileId}>Check validation status</Link>.
          When ready, enter this version ID in the appropriate lesson above.
        </p>
      )}
    </>
  );
}
